import React from 'react';
import { useTranslation } from 'react-i18next';
import Row from './Row';
import { SmallText } from '../Text/FontStyles';

type PropsType = {
    value?: string,
    optionText: any,
    name: string,
    checked?: boolean,
    type: 'checkbox' | 'radio'
    onChange: () => void,
    id?: string,
    textStyle?: any,
    containerStyle?: any,
    inputStyle?:any,
};

const CheckBox = ({
    value,
    optionText,
    name,
    checked,
    type = 'checkbox',
    onChange,
    textStyle = {},
    containerStyle = {},
    inputStyle = {'width':'30px'},
}: PropsType) => {
    const { i18n } = useTranslation();
    const isChinese = i18n.language === 'zhTW' || i18n.language === 'cn';
    return (<Row key={`checkbox-${name}-${value}`} style={containerStyle}>
        <input
            type={type}
            name={name}
            checked={checked}
            onChange={onChange}
            style={inputStyle}
        />
        <SmallText style={textStyle} isChinese={isChinese}>{optionText}</SmallText>
    </Row>);
};

export default CheckBox;
